angular.module('impactx.cancellation').directive('ixCancelDetailRow', function () {
    return {
        scope: {
            item: '=',
            position: '=',
            trns: '=',
            cancelBasketItemGroup: "&"
        },
        controller: 'CancelItemController',
        templateUrl: 'modules/cancellation/templates/cancellation-detail-row.tmpl.html',
        restrict: 'E'
    }
});